import { LegalContent } from '@/components/legal/LegalContent';
import { PRIVACY_POLICY_CONTENT_BLOCKS } from '@/lib/privacy-policy';

export default function PrivacyPolicy() {
  return (
    <article className="mx-auto w-full max-w-4xl px-4 py-10 sm:px-6 sm:py-14 lg:px-8">
      <LegalContent blocks={PRIVACY_POLICY_CONTENT_BLOCKS} />
    </article>
  );
}
